import {
  Route,
  createRoutesFromElements,
  RouterProvider,
  createBrowserRouter
} from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import LoginPage from "./pages/LoginPage.jsx";
import MainLayout from "./pages/MainLayout.jsx";
import EventListView from "./components/EventListView/EventListView.jsx";
import GameListView from "./components/GameListView/GameListView.jsx";
import LogListView from "./components/LogListView/LogListView.jsx";
import Initializer from "./components/Initializer/Initializer.jsx";
import PublicOnlyRoute from "./components/PublicRoute/PublicRoute.jsx";
import PrivateRoute from "./components/PrivateRoute/PrivateRoute.jsx";
import HomeView from "@shared/components/HomeView/HomeView.jsx";
import Logout from "./components/Logout/Logout.jsx";
import { initializeFaro, withFaroRouterInstrumentation } from '@grafana/faro-react';
import TeamStatsOverView from './components/TeamStatsOverView/TeamStatsOverView.jsx';
import TeamDetailView from "./components/TeamDetailView/TeamDetailView.jsx";
import VideoView from "./components/VideoView/VideoView.jsx";
initializeFaro({
  url: 'my/collector/url',

  app: {
    name: 'VAT-Frontend',
  },
});
export function getUrl() {
  return import.meta.env.PROD ? "https://vat.berlin-united.com" : "http://localhost:8000";
};
const appVersion = "0.0.1";
const queryClient = new QueryClient();

const routes = createRoutesFromElements(
  <>
    <Route path="/" element={<Initializer />}>
      <Route element={<PrivateRoute />}>
        {/* everything that should be only accessible to logged in users belongs here */}
        <Route element={<MainLayout appVersion={appVersion} />}>
          <Route index element={<HomeView />} />
          <Route path="/teams" element={<TeamStatsOverView />} />
          <Route path="/team/:id" element={<TeamDetailView />} />
          <Route path="/events" element={<EventListView />} />
          <Route path="/events/:id" element={<GameListView />} />
          <Route path="/games/:id" element={<LogListView />} />
          <Route path="/videos/:id" element={<VideoView />} />
          {/* TODO: Build ImageViewer */}
          <Route path="/logs/:id" element={<LogListView />} />
          <Route path="/logout" element={<Logout />} />
           {/* everything that uses main layout belongs here */}
        </Route>
      </Route>
    </Route>
    
    <Route path="/login" element={<PublicOnlyRoute />}>
      <Route index element={<LoginPage />} />
    </Route>
  </>
);

const reactBrowserRouter = createBrowserRouter(routes);
const InstrumentedRouter = withFaroRouterInstrumentation(reactBrowserRouter);

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={InstrumentedRouter} />
    </QueryClientProvider>
  );
}

export default App;